class FelixCarousel extends window.BAO.CustomElement {
  constructor () {
    super()

    this.observeItems()

    if (this.els.slide.elements.length < 2) return

    this.initialiseCarousel()
  }

  observeItems () {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.els.felix.element.classList.remove(
              'sec-FelixCarousel_Felix-hidden'
            )
            this.els.felix.element.classList.add(
              'sec-FelixCarousel_Felix-visible'
            )
          } else {
            this.els.felix.element.classList.add(
              'sec-FelixCarousel_Felix-hidden'
            )
            this.els.felix.element.classList.remove(
              'sec-FelixCarousel_Felix-visible'
            )
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.7
      }
    )

    observer.observe(this)
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    const slider = new window.KeenSlider685(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: 'auto',
        spacing: 8
      }
    })

    const containerWidth = this.els.slides.element.clientWidth
    const scrollerWidth = (containerWidth / this.slidesWidth) * 100

    this.els.scroller.element.style.width = `${scrollerWidth}%`

    slider.on('slideChanged', () => {
      const inteval = window.setInterval(() => {
        const moveAmount = slider.track.details.progress * this.maxMove

        this.els.scroller.element.style.left = `${moveAmount}px`
      }, 20)
      window.setTimeout(() => {
        window.clearInterval(inteval)
      }, 400)
    })
  }

  get slidesWidth () {
    let totalWidth = 0
    this.els.slide.elements.forEach(slide => {
      totalWidth += slide.clientWidth + 8
    })
    return (totalWidth += 22)
  }

  get maxMove () {
    return (
      this.els.slides.element.clientWidth -
      30 -
      this.els.scroller.element.clientWidth
    )
  }
}

if (!customElements.get('felix-carousel')) {
  customElements.define('felix-carousel', FelixCarousel)
}
